import { ExperimentWrapper } from '@/features/experiments/experiment-wrapper';
const HomepageExperiment = () => {
  return <ExperimentWrapper experimentTitle='debug_homepage_experiment' fallback={null} versions={{
    with_element: (expTitle, version) => <span data-exp={`${expTitle}: ${version}`} className='invisible hidden' />,
    without_element: null
  }} data-sentry-element="ExperimentWrapper" data-sentry-component="HomepageExperiment" data-sentry-source-file="homepage-experiments.tsx" />;
};
export default HomepageExperiment;